<script>
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

export default {
  name: 'DateFormatMixin',
  methods: {
    yearFormatter(date) {
      return dayjs(date).format('DD MMMM YYYY');
    },
    hoursFormatter(date) {
      return dayjs(date).format('HH:mm a').toLocaleString();
    },
    durationFormatter(seconds) {
      return dayjs.duration(seconds, 'seconds').format('HH:mm:ss');
    },
    getTimeLeft(startTime) {
      const now = dayjs(); // todays date
      const end = dayjs(startTime); // another date

      dayjs.extend(duration);
      dayjs.extend(relativeTime);

      const durationMoment = dayjs.duration(end.diff(now));
      const seconds = durationMoment.asSeconds();
      if (seconds <= 0) return '';

      return dayjs.duration(seconds, 'seconds').humanize();
    },
    hasEventStarted() {},
  },
};
</script>
